/* eslint-disable */
/* ⚠️ DO NOT EDIT ⚠️ */
/* This file is automatically generated, run 'pnpm codegen' to update */
import * as Types from '../../../__generated__/schema.types';

import { gql } from '@apollo/client';
export type CmhtmlFragment = { __typename?: 'CMHTMLImpl', id: string, activeElement?: boolean | null, html?: string | null, htmlSettings?: any | null };

export const CmhtmlFragmentDoc = gql`
    fragment CMHTML on CMHTML {
  id
  activeElement
  html
  htmlSettings: settings(paths: ["placeholders"])
}
    `;